import { fetchStartupRead, invalidateStartupReads } from './startupRequests';
import type { RolePreview } from '../roles/rolePreview';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const isRolePreview = (value: unknown): value is RolePreview =>
  value === 'super_admin' || value === 'regular' || value === 'ce'
  || value === 'ra' || value === 'dcma' || value === 'admin';

export async function getServerRolePreview(options?: { fresh?: boolean }): Promise<RolePreview> {
  // A focus/retry refresh must not join a read from an earlier signed cookie.
  const read = options?.fresh ? fetch : fetchStartupRead;
  const response = await read(`${API_BASE_URL}/api/auth/role-preview`, {
    credentials: 'include',
  });
  if (!response.ok) throw new Error('Could not load the active role view.');
  const payload = await response.json();
  if (!isRolePreview(payload.role)) throw new Error('Invalid active role view.');
  return payload.role;
}

export async function setServerRolePreview(role: RolePreview): Promise<RolePreview> {
  invalidateStartupReads();
  try {
    const response = await fetch(`${API_BASE_URL}/api/auth/role-preview`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ role }),
    });
    if (!response.ok) throw new Error('Could not change the active role view.');
    const payload = await response.json();
    if (!isRolePreview(payload.role) || payload.role !== role) {
      throw new Error('The active role view did not match the selection.');
    }
    return payload.role;
  } finally {
    // Cookie changes also invalidate reads started during the mutation.
    invalidateStartupReads();
  }
}
